import dayjs from 'dayjs';
import SalaryReview from './SalaryReview';
import Allowance from './Allowance';

export default class SalaryReviewAllowance {
  constructor(data) {
    this.id = data?.id;
    this.salaryReviewId = data?.salaryReviewId;
    this.allowanceId = data?.allowanceId;
    this.amount = data?.amount ? Number(data.amount) : 0;
    this.createdAt = data?.createdAt ? dayjs(data.createdAt) : null;
    this.updatedAt = data?.updatedAt ? dayjs(data.updatedAt) : null;

    this.salaryReview = data?.salaryReview ? new SalaryReview(data?.salaryReview) : null;
    this.allowance = data?.allowance ? new Allowance(data?.allowance) : null;
  }
}
